import { render } from "./page_api_1.vue?vue&type=template&id=0361c895"
import script from "./page_api_1.vue?vue&type=script&lang=js"
export * from "./page_api_1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__